<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard class="mb-6">
    <template #header>
      <ContentCardSubheader>
        <span class="line-clamp-1">{{ leadName }}</span>
        <template v-if="lead" #actions>
          <div class="flex flex-col items-end" data-testid="lead-detail-last-interaction">
            <span class="txt-label-s text-subtlest">{{ t('LeadDetail.field.lastInteractionAt') }}</span>
            <time :datetime="lead.latestRequestAt" class="txt-body-s whitespace-nowrap">{{
              d(lead.latestRequestAt, 'dateTimeShort')
            }}</time>
          </div>
        </template>
      </ContentCardSubheader>
    </template>
    <LeadDetailDataProvider :lead-id="leadId" context="agency" @update:lead="lead = $event" />
    <template v-if="lead" #footer>
      <LeadArchiveAction :lead-id="lead.id" :archived="!!lead.archivedAt" />
    </template>
  </ContentCard>
  <ContentCard v-if="lead">
    <LeadRequestHistory class="py-6" :requests="lead.contactRequests" />
  </ContentCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import LeadArchiveAction from '@/components/ReviewsCommon/Leads/LeadArchiveAction.vue'
import LeadDetailDataProvider from '@/components/ReviewsCommon/Leads/LeadDetailDataProvider.vue'
import LeadRequestHistory from '@/components/ReviewsCommon/Leads/LeadRequestHistory.vue'
import type { LeadDetailData } from '@/components/ReviewsCommon/Leads/types'
import { useReviewsAgencyBreadcrumbs } from '@/composables/breadcrumbs/useReviewsAgencyBreadcrumbs'
import type { AgencyData } from '@/gql/reviews'
import { useRoleRedirect } from '@/services/roleRedirect'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

const props = defineProps<{
  agency: AgencyData
  leadId: string
}>()

const { t, d } = useI18n()

useRoleRedirect('viewReviewsAgencyLeads')

const lead = ref<LeadDetailData | null>()
const leadName = computed(() => lead.value?.senderName || lead.value?.senderEmail || '')
const breadcrumbs = useReviewsAgencyBreadcrumbs(props.agency, leadName)
</script>
